import {
  Component,
  EventEmitter,
  Inject,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { CaptchaService } from '../../services/captcha.service';
import { CaptchaSettings } from '../../models/сaptcha';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CaptchaComponent implements OnDestroy, OnChanges {
  @Input() showCaptcha: boolean;
  @Output() captchaPassed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('humanometrWrapper', { static: false }) humanometrWrapper: ElementRef;

  private _humanometrEventListener: (event: Event) => void;
  public settings$: BehaviorSubject<CaptchaSettings> = this._captchaService.settings$;

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _captchaService: CaptchaService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showCaptcha && changes.showCaptcha.currentValue === true && this.settings$.value) {
      setTimeout(() => this.initSettings(this.settings$.value), 0);
    }
  }

  public onSuccessHandler(): void {
    this.captchaPassed.emit(true);
  }
  public closeCaptcha(): void {
    this._captchaService.isCaptchaVisible = false;
    this.onSuccessHandler();
  }
  private _initHumanoMeterListener(): void {
    if (this._humanometrEventListener) {
      this._document.removeEventListener('HumanometrEvent', this._humanometrEventListener);
    }

    this._humanometrEventListener = (event: Event) => {
      const customEvent = event as CustomEvent;

      if (customEvent.detail.name === 'ChallengeReadyEvent') {
        this.captchaPassed.emit(!customEvent.returnValue);
      }
      if (customEvent.detail.name === 'ChallengePassEvent') {
        const widgetElement = this.humanometrWrapper.nativeElement.querySelector('#hm_feedback');
        if (widgetElement && typeof widgetElement.getToken === 'function') {
          widgetElement.getToken().then(token => {
            this._captchaService.captchaToken$ = token;
            this._captchaService.isCaptchaPassed = true;
          });
        }

      }
    };
    this._document.addEventListener('HumanometrEvent', this._humanometrEventListener);
  }

  private initSettings(settings: CaptchaSettings): void {
    if (settings) {
      this.humanometrWrapper.nativeElement.innerHTML = '';
      this.humanometrWrapper.nativeElement.innerHTML = `
        <humanometr-widget
          #hm_feedback
          brand-ticket="false"
          brand-label="true"
          id="hm_feedback"
          host="${settings?.Host}"
          siteKey="${settings?.SiteKey}"
        >
        </humanometr-widget>`;
      this._initHumanoMeterListener();
    } else {
      this.captchaPassed.emit(true);
    }
  }

  ngOnDestroy(): void {
    this._document.removeEventListener('HumanometrEvent', this._humanometrEventListener);
  }
}
